import { Button, Css, useSnackbar, useTestIds } from "@homebound/beam";
import { Icon } from "src/components";
import { BidPackageDetailPageDocument } from "src/routes/bids/BidPackageDetailPage.generated";
import { useReviewBidPackageIncomingUpdatesMutation } from "src/routes/bids/components/ReviewBidPackageIncomingUpdates.generated";
import { ReviewScopeChangesCard_IncomingUpdateFragment } from "src/routes/bids/components/ReviewScopeChangesCard.generated";
import { PlanBasedBidsTableV2_BidPlanChildGroupsDocument } from "src/routes/bids/plan-based-bid-package/components/PlanBasedBidsTableV2.generated";

type ReviewScopeChangesCardProps = {
  bidPackageId: string;
  productOfferingId: string;
  planName: string;
  updates: readonly ReviewScopeChangesCard_IncomingUpdateFragment[];
};

export function ReviewScopeChangesCard({
  bidPackageId,
  productOfferingId,
  planName,
  updates,
}: ReviewScopeChangesCardProps) {
  const [reviewUpdates, { loading }] = useReviewBidPackageIncomingUpdatesMutation();
  const { triggerNotice } = useSnackbar();
  const tid = useTestIds({});
  if (updates.isEmpty) return null;
  const latestVersion = updates.map((u) => u.source.version ?? 0).max();

  async function onMarkReviewed() {
    await reviewUpdates({
      variables: { input: { bidPackageId, productOfferingId } },
      refetchQueries: [BidPackageDetailPageDocument, PlanBasedBidsTableV2_BidPlanChildGroupsDocument],
    });
    triggerNotice({ message: "Scope changes marked as reviewed." });
  }

  return (
    <div {...tid.card} css={Css.bgWhite.ba.bcBlue700.bw2.br12.p2.df.gap1.mb2.$}>
      <div>
        <Icon icon="refresh" />
      </div>
      <div css={Css.w100.df.fdc.$}>
        <span css={Css.mdSb.pb1.$}>
          Scope updates from {planName} v{latestVersion}
        </span>
        <span css={Css.sm.gray700.$}>
          Please review scope changes detailed below. Scope updates will never remove costs from your bid.
        </span>
      </div>
      <div>
        <Button label="Mark as Reviewed" variant="secondary" disabled={loading} onClick={onMarkReviewed} />
      </div>
    </div>
  );
}
